import {
  type Bet as SearchBet,
  type BetResult as SearchBetResult,
  type HorseRacingSportsData as SearchHorseRacingSportsData,
  type Line as SearchLine,
  type Market as SearchMarket,
  type MarketClassification as SearchMarketClassification,
  type MarketDisplayNames as SearchMarketDisplayNames,
  type MarketMovement as SearchMarketMovement,
  type Participant as SearchParticipant,
  type ParticipantSide as SearchParticipantSide,
  type ParticipantType as SearchParticipantType,
  type Q4Type as SearchQ4Type,
  type SportsData as SearchSportsData,
  type SportsDataTeam as SearchSportsDataTeam,
  type StatsTable as SearchStatsTable,
  type StatsTableCell as SearchStatsTableCell,
  type StatsTableColumn as SearchStatsTableColumn,
  type StatsTableRow as SearchStatsTableRow,
  type Subevent as SearchSubevent,
  type SubeventTeamData as SearchSubeventTeamData,
  type TeamData as SearchTeamData,
} from '~/search-domain/types/betting-insight';
import { type Repub, REPUBS } from '~/vendor/cx-modules/constants';

export function isGzRepub(repub: Repub | string): boolean {
  return repub === REPUBS.GZ.name;
}

export type MarketDisplayNames = SearchMarketDisplayNames;
export type Line = SearchLine;
export type Subevent = SearchSubevent;
export type Market = SearchMarket;
export type MarketClassification = SearchMarketClassification;
export type Bet = SearchBet;
export type TeamData = SearchTeamData;
export type SubeventTeamData = SearchSubeventTeamData;
export type StatsTableColumn = SearchStatsTableColumn;
export type StatsTableRow = SearchStatsTableRow;
export type StatsTableCell = SearchStatsTableCell;
export type StatsTable = SearchStatsTable;
export type SportsData = SearchSportsData;
export type SportsDataTeam = SearchSportsDataTeam;
export type BetResult = SearchBetResult;
export type ParticipantSide = SearchParticipantSide;
export type ParticipantType = SearchParticipantType;
export type Participant = SearchParticipant;
export type Q4Type = SearchQ4Type;
export type HorseRacingSportsData = SearchHorseRacingSportsData;
export type MarketMovement = SearchMarketMovement;
